import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { PlusOutlined } from "@ant-design/icons";

import SurveyViewsTable from "@/views/survey-views/components/SurveyViewTable";
import { useGetCurrentUserQuery } from "@/redux/service";
import BaseButton from "@/components_v2/Button/BaseButton";

import "./styles.css";
import {OrganizationRoles, Roles} from "@/utilities/constants";

const SurveyViewList = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { data: currentUser } = useGetCurrentUserQuery();

  const defaultFilters = useMemo(() => {
    if (currentUser) {
      if (currentUser.role === Roles.ADMIN.value) {
        return {}
      }
      return {
        organization: currentUser.organization.id,
      };
    }
  }, [currentUser]);

  const canCreateSurveyView = useMemo(() => {
    return (
      currentUser &&
      currentUser.organizationRole &&
      [
        OrganizationRoles.ADMIN.value,
        OrganizationRoles.SUPERVISOR.value,
      ].includes(currentUser.organizationRole)
    );
  }, [currentUser]);

  return (
    <div className="survey-view-list-container">
      <div className="survey-view-list-header">
        <h1 className="header-l-medium">
          {t("surveyViews.labels.publishAndShare")}
        </h1>
        {canCreateSurveyView && (
          <BaseButton
            size="small"
            leadingIcon={<PlusOutlined />}
            onClick={() => navigate("/reports/views/form")}
          >
            {t("surveyViews.labels.generateNewSurveyView")}
          </BaseButton>
        )}
      </div>
      {defaultFilters && (
        <SurveyViewsTable
          columnNames={[
            "title",
            "description",
            "dataFormat",
            "survey",
            "createdAt",
            "actions",
          ]}
          filterNames={["search", "survey", "dataFormat", "distributionFormat"]}
          defaultFilters={defaultFilters}
        />
      )}
    </div>
  );
};

export default SurveyViewList;
